<formly-form
  [model]="model"
  [fields]="[
    {
      type: 'input',
      key: 'sword',
      wrappers: [],
      props: {
        placeholder:
          placeholder ?? 'components.searchBox.placeholder' | translate,
        size: 'small',
        prefix: prefixTemplateSearch,
        suffix: suffixTemplateSearch,
      },
    },
  ]"
  [form]="form"
  (modelChange)="onModelChange()"
/>

<ng-template #prefixTemplateSearch>
  <svg-icon src="assets/icons/General/search-sm.svg" class="text-grey-300" />
</ng-template>
<ng-template #suffixTemplateSearch>
  @if (model.sword !== '') {
    <svg-icon
      src="assets/icons/General/x-circle.svg"
      class="size-5 cursor-pointer text-grey-600"
      (click)="onClear()"
      (keydown)="onClear()"
    />
  }
</ng-template>
